var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rt-step"},[_c('van-steps',{attrs:{"active":_vm.active}},[_c('van-step',[_vm._v("选择查询类型")]),_c('van-step',[_vm._v("查询")]),_c('van-step',[_vm._v("验证信息并核销")]),_c('van-step',[_vm._v("完成")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }